import { OptimisticMutationConfig } from "@urql/exchange-graphcache";
import { isNil } from "lodash";

import {
  MutationUpdateBlueprintMetadataArgs,
  MutationUpdateDirectoryArgs,
  MutationUpdateFileArgs,
  MutationUpdateSessionArgs,
  MutationUpdateStyleArgs,
  MutationUpdateTrainingRunArgs,
  MutationUpdateWorkspaceArgs,
} from "./schema.graphql";

export const optimisticConfig: OptimisticMutationConfig = {
  updateWorkspace: ({ input }: MutationUpdateWorkspaceArgs, _cache) => {
    const fields: Record<string, unknown> = {
      __typename: "Workspace",
      id: input.workspaceId,
    };
    if (!isNil(input.disabledModalities))
      fields.disabledModalities = input.disabledModalities;
    if (!isNil(input.disabledBaseModelIds))
      fields.disabledBaseModelIds = input.disabledBaseModelIds;
    return fields;
  },

  updateFile: ({ input }: MutationUpdateFileArgs, _cache) => {
    const fields: Record<string, unknown> = {
      __typename: "File",
      id: input.fileId,
    };
    if (!isNil(input.isLiked)) fields.isLiked = input.isLiked;
    if (!isNil(input.isPosted)) fields.isPosted = input.isPosted;
    if (!isNil(input.name)) fields.name = input.name;
    return fields;
  },

  updateStyle: ({ input }: MutationUpdateStyleArgs, _cache) => {
    const fields: Record<string, unknown> = {
      __typename: "Style",
      id: input.styleId,
    };
    if (!isNil(input.isLiked)) fields.isLiked = input.isLiked;
    if (!isNil(input.isPinned)) fields.isPinned = input.isPinned;
    return fields;
  },

  updateSession: ({ input }: MutationUpdateSessionArgs, _cache) => {
    const fields: Record<string, unknown> = {
      __typename: "Session",
      id: input.sessionId,
    };
    if (!isNil(input.name)) fields.name = input.name;
    if (!isNil(input.status)) fields.status = input.status;
    return fields;
  },

  updateDirectory: ({ input }: MutationUpdateDirectoryArgs, _cache) => {
    const fields: Record<string, unknown> = {
      __typename: "Directory",
      id: input.directoryId,
    };
    if (!isNil(input.name)) fields.name = input.name;
    return fields;
  },

  updateTrainingRun: ({ input }: MutationUpdateTrainingRunArgs, _cache) => {
    const fields: Record<string, unknown> = {
      __typename: "TrainingRun",
      id: input.trainingRunId,
    };
    if (!isNil(input.name)) fields.name = input.name;
    return fields;
  },

  updateBlueprintMetadata: (
    { input }: MutationUpdateBlueprintMetadataArgs,
    _cache,
  ) => {
    const fields: Record<string, unknown> = {
      __typename: "Blueprint",
      id: input.blueprintId,
    };
    if (!isNil(input.isLiked)) fields.isLiked = input.isLiked;
    if (!isNil(input.isPinned)) fields.isPinned = input.isPinned;
    if (!isNil(input.visibility)) fields.visibility = input.visibility;
    if (!isNil(input.name)) fields.name = input.name;
    // An explicit null clears the description, so null is a value here.
    if (input.description !== undefined) fields.description = input.description;
    return fields;
  },
};
